import React from 'react';

import Checkbox from './Checkbox';

type Props = React.ComponentPropsWithoutRef<typeof Checkbox>;

export default (props: Props) => (
    <Checkbox
        {...props}
        iconProps={{
            true: {
                src: '/icons/ic-toggle-selected.svg',
                width: 42,
                height: 24,
            },
            false: {
                src: '/icons/ic-toggle.svg',
                width: 42,
                height: 24,
            },
        }}
    />
);
